module.exports = __webpack_public_path__ + "static/media/play-next.d0632b5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-next.svg
// module id = ./src/assets/images/play-next.svg
// module chunks = 0